module.exports = __webpack_public_path__ + "static/media/JSNMC3.7412a96c.png";